import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import Index from "./pages/Index";
import CaseStudies from "./pages/CaseStudies";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import BriansStory from "./pages/BriansStory";
import KayleeBell from "./pages/KayleeBell";
import Waitlist from "./pages/Waitlist";
import ReleaseGuide from "./pages/ReleaseGuide";
import LinkTree from "./pages/LinkTree";
import OneKFanFinder from "./pages/OneKFanFinder";
import MailingList from "./pages/MailingList";
import ContentIdeas from "./pages/ContentIdeas";
import ContentCheatCode from "./pages/ContentCheatCode";
import FanbaseFix from "./pages/FanbaseFix";
import FanbaseFixReview from "./pages/FanbaseFixReview";
import BlackFriday from "./pages/BlackFriday";
import BlackFridayConfirmed from "./pages/BlackFridayConfirmed";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/briansstory" element={<BriansStory />} />
          <Route path="/kayleebell" element={<KayleeBell />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/release-guide" element={<ReleaseGuide />} />
          <Route path="/dk" element={<LinkTree />} />
          <Route path="/1kfans" element={<OneKFanFinder />} />
          <Route path="/mailing-list" element={<MailingList />} />
          <Route path="/365-content-ideas" element={<ContentIdeas />} />
          <Route path="/365" element={<ContentIdeas />} />
          <Route path="/cheat-code" element={<ContentCheatCode />} />
          <Route path="/fanbase-fix" element={<FanbaseFix />} />
          <Route path="/fanbase-fix/review" element={<FanbaseFixReview />} />
          <Route path="/black-friday" element={<BlackFriday />} />
          <Route path="/black-friday/confirmed" element={<BlackFridayConfirmed />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
